<div class="suggestion-form__view">
    @if (!requestSuccessful) {
        <app-dynamic-form
            submitButtonText="Vorschlag absenden"
            [formControls]="formModel"
            [textAreaControl]="formTextArea"
            [smallForm]="true"
            (successSubmit)="submit($event.formGroupData)"></app-dynamic-form>
    } @else {
        <div class="suggestion-form__success">
            <div class="suggestion-form__success__title">
                <dynamo-icon dynamoIconType="confetti" manualSize="2rem"></dynamo-icon>
                <span class="dynamic__text dynamic__text--bold">Vielen Dank!</span>
            </div>
            <span class="dynamic__text--sm dynamic__text--center"
                >Wir haben deinen Restaurantvorschlag erfolgreich erhalten.</span
            >
        </div>
    }
</div>
